import { alpha } from '@mui/material/styles';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { gray, brand, red, green, orange } from '../getDesignTokens'; // Import your color palette

export const iconCustomizations = {
  MuiSvgIcon: {
    defaultProps: {
      fontSize: 'medium', 
    },
    styleOverrides: {
      root: ({ theme }) => ({
        transition: 'color 150ms ease-in-out, transform 150ms ease-in-out',
        color: theme.palette.text.primary, 
        width: '1.5rem',
        height: '1.5rem',
        // Keep adornment/autocomplete icons compact and stable
        '.MuiInputAdornment-root &': {
          width: 18,
          height: 18,
          transform: 'none',
          '&:hover, &:active': { transform: 'none', color: theme.palette.text.secondary },
        },
        '.MuiAutocomplete-root &': {
          width: 18,
          height: 18,
          transform: 'none',
          '&:hover, &:active': { transform: 'none', color: theme.palette.text.secondary },
        },

        '&.MuiSvgIcon-colorPrimary': {
          color: theme.palette.primary.main,
        },
        '&.MuiSvgIcon-colorSecondary': {
          color: brand[500],
        },
        '&.MuiSvgIcon-colorSuccess': {
          color: green[500],
        },
        '&.MuiSvgIcon-colorError': {
          color: red[500],
        },
        '&.MuiSvgIcon-colorWarning': {
          color: orange[500],
        },

        '&:hover': {
          transform: 'scale(1.1)',
          color: theme.palette.primary.dark,
        },
        '&:active': {
          transform: 'scale(0.95)',
        },

        // Dark Mode Adjustments
        ...theme.applyStyles('dark', {
          color: gray[300],
          '&.MuiSvgIcon-colorPrimary': {
            color: brand[300],
          },
          '&.MuiSvgIcon-colorSecondary': {
            color: brand[400],
          },
          '&.MuiSvgIcon-colorSuccess': {
            color: green[300],
          },
          '&.MuiSvgIcon-colorError': {
            color: red[300],
          },
          '&.MuiSvgIcon-colorWarning': {
            color: orange[300],
          },
          '&:hover': {
            color: theme.palette.primary.light,
          },
        }),
      }),
    },
  },
};
